import { Star, ExternalLink, MessageSquareQuote } from 'lucide-react';

const REVIEW_URL =
  process.env.REACT_APP_GOOGLE_REVIEW_URL ||
  'https://www.google.com/search?q=Better+Fence+and+Deck+Shreveport+LA&hl=en';

export default function ReviewCTA() {
  return (
    <section
      id="leave-review"
      data-testid="review-cta-section"
      className="py-20 lg:py-24 bg-ink relative overflow-hidden border-t border-white/5"
    >
      {/* Ambient gold glow */}
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 30%, #d4a13a 0%, transparent 45%), radial-gradient(circle at 85% 70%, #d4a13a 0%, transparent 40%)',
        }}
      />

      <div className="max-w-5xl mx-auto px-5 md:px-8 relative">
        <div className="rounded-lg border border-gold/30 bg-ink-panel/70 backdrop-blur-sm p-8 md:p-12 shadow-2xl">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-10">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center">
                <MessageSquareQuote className="w-9 h-9 text-gold" />
              </div>
            </div>

            <div className="flex-1">
              <div className="eyebrow">Enjoyed working with us?</div>
              <h2 className="mt-3 font-display uppercase text-3xl md:text-4xl lg:text-5xl text-cream leading-[1.02] tracking-tight">
                Leave us a Google review.
              </h2>
              <p className="mt-4 text-cream/70 text-base md:text-lg leading-relaxed max-w-xl">
                A small local crew like ours lives and dies by word of mouth. Thirty seconds of your
                time means the world &mdash; and helps your neighbors find a fence contractor they
                can trust.
              </p>

              <div className="mt-6 flex items-center gap-1 text-gold">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-6 h-6 fill-gold" />
                ))}
                <span className="ml-3 text-cream/60 text-sm">4.9 average &middot; verified reviews</span>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={REVIEW_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="google-review-button"
                  className="btn-primary justify-center py-4"
                >
                  <Star className="w-4 h-4 fill-ink" />
                  Review us on Google
                  <ExternalLink className="w-3.5 h-3.5 opacity-70" />
                </a>
                <a
                  href="#reviews"
                  data-testid="read-reviews-link"
                  className="btn-outline justify-center py-4"
                >
                  Read what neighbors say
                </a>
              </div>

              <div className="mt-5 text-xs text-cream/40">
                Something wasn&rsquo;t perfect? Call{' '}
                <a href="tel:3183447190" className="text-gold hover:underline">
                  318-344-7190
                </a>{' '}
                first &mdash; we&rsquo;ll make it right.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
